import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKeyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M12.906 4.525c0 .48-.422.868-.941.868-.52 0-.942-.388-.942-.868s.422-.869.942-.869.94.39.94.869"
    />
    <path
      fill="#000"
      d="M10.55 1.047c-2.895 0-5.176 2.105-5.176 4.777 0 .345.038.691.114 1.02.055.235-.007.438-.133.554l-4.274 3.944a1.25 1.25 0 0 0-.413.922v1.377c0 .72.632 1.303 1.412 1.303h1.882c.78 0 1.412-.583 1.412-1.303v-.434h.941c.52 0 .941-.39.941-.869v-.868h.941c.52 0 .942-.39.942-.869v-.156c.464.116.947.156 1.411.156 2.895 0 5.177-2.105 5.177-4.777s-2.282-4.777-5.177-4.777M6.315 5.824c0-2.192 1.86-3.909 4.235-3.909s4.236 1.717 4.236 3.909-1.86 3.909-4.236 3.909c-.62 0-1.197-.083-1.672-.302a.5.5 0 0 0-.457.019.43.43 0 0 0-.224.37v.781h-.94c-.52 0-.942.389-.942.869v.868h-.941c-.52 0-.941.39-.941.869v.434c0 .24-.211.434-.47.434H2.08c-.26 0-.47-.194-.47-.434v-1.377c0-.115.049-.226.137-.307l4.274-3.944c.406-.376.491-.907.387-1.352a3.7 3.7 0 0 1-.093-.837"
    />
  </svg>
);
export default SvgKeyIcon;
